import { render, staticRenderFns } from "./TopBlock.vue?vue&type=template&id=4479d490&scoped=true"
import script from "./TopBlock.vue?vue&type=script&lang=js"
export * from "./TopBlock.vue?vue&type=script&lang=js"
import style0 from "./TopBlock.vue?vue&type=style&index=0&id=4479d490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479d490",
  null
  
)

export default component.exports